module.exports = __webpack_public_path__ + "static/media/man-transfering-bitcoin-using-application.9b2a7d7b.png";